import _ from 'lodash';
import {cloneObject, tmpId} from '@tools/helpers';
import {any} from 'prop-types';

class LocalStorageManagerMock {
  key
  type : 'string' | 'array'
  constructor(key, type) {
    this.key = key;
    this.type = type;
  }
  set(value) {
    return true
  }
  get() {
    return this.type === 'array' ? [] : ''
  }
  add(value) {
    return true;
  }
  clear() {
    return true;
  }
  remove(value) {
    return true;
  }

  exists() {
    return false;
  }
}
class LocalStorageManager {
  key
  type : 'string' | 'array'
  constructor(key, type) {
    this.key = key;
    this.type = type;
  }

  set(value) {
    localStorage.setItem(this.key, JSON.stringify(value));
  }

  add(value) {
    const val = this.get();
    if (this.type === 'string') {
      localStorage.setItem(this.key, JSON.stringify(val + value));
      return true;
    } else if (this.type === 'array') {
      if (val.includes(value)) {
        return true
      } else {
        val.push(value)
        localStorage.setItem(this.key, JSON.stringify(val));
        return true;
      }
    }
  }

  get() {
    const value = localStorage.getItem(this.key);
    return value ? JSON.parse(value) : (this.type === 'array' ? [] : '');
  }

  clear() {
    localStorage.removeItem(this.key);
  }

  remove(value) {
    let val = this.get();
    if (this.type === 'string') {
      localStorage.removeItem(this.key);
      return true;
    } else if (this.type === 'array') {
      let removed = val.splice(val.findIndex(item => item === value), 1);
      localStorage.setItem(this.key, JSON.stringify(val));
      return removed;
    }
  }

  exists(value) {
    const storedValue = this.get();
    if (Array.isArray(storedValue)) {
      return storedValue.includes(value);
    }
    return storedValue === value;
  }
}

class DataStorage {
  current_city
  comparison_offers
  constructor() {
    if (typeof localStorage === 'undefined') {
      this.current_city = new LocalStorageManagerMock('current_city', 'string');
      this.comparison_offers = new LocalStorageManagerMock('comparison_offers', 'array');

    } else {
      this.current_city = new LocalStorageManager('current_city', 'string');
      this.comparison_offers = new LocalStorageManager('comparison_offers', 'array');
    }
  }
}

export default DataStorage
